import { Box } from "@mui/material";
import { Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material";

const WidgetFooter = props => {
  const { text = "Powered By: Omniscia Health" } = props;

  const theme = useTheme();
  const omnisciaLogo = `${window.location.origin}/omnisciaLogo.png`;

  return (
    <Box
      sx={{
        paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(1),
        paddingBottom: 0,
        maxHeight: 36,
        minHeight: 36,
        display: "flex",
        flexDirection: "row",
        userSelect: "none",
        webkitUserSelect: "none",
        position: "absolute",
        bottom: 0,
        width: "100%",
        borderTop: `1px solid ${alpha(theme.palette.commonground.contrastText, 0.25)}`,
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            background: `url(${omnisciaLogo})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            width: "16px",
            height: "16px",
            margin: "4px",
          }}
        />
        <Typography
          variant="overline"
          sx={{
            marginTop: "2px",
          }}
        >
          {
            <Link
              href={"https://www.omnisciahealth.com/"}
              to="route"
              target="_blank"
              sx={{ color: theme.palette.primary.main }}
              onClick={() => {
                // gtag("event", "user_onboarding_privacy_policy", {
                //   invite_key: inviteKey,
                // });
              }}
            >
              {text}
            </Link>
          }
        </Typography>
      </Box>
    </Box>
  );
};

export default WidgetFooter;
